export const NOMINATION_FIELD_MAX_LENGTH = 1500;

export interface NominationFormFields {
  wins: string;
  comments: string;
  reason: string;
}

export type NominationValidationErrors = Partial<Record<keyof NominationFormFields, string>>;

/** Pure field validation shared by the dialog (inline feedback) and the service (last line of defence). */
export function validateNominationFields(fields: NominationFormFields): NominationValidationErrors {
  const errors: NominationValidationErrors = {};
  if (!fields.wins.trim()) errors.wins = 'Describe at least one specific win or achievement.';
  if (!fields.reason.trim()) errors.reason = 'Explain why this client deserves the nomination.';
  (['wins', 'comments', 'reason'] as const).forEach(key => {
    if (fields[key].length > NOMINATION_FIELD_MAX_LENGTH) {
      errors[key] = `Keep this under ${NOMINATION_FIELD_MAX_LENGTH} characters.`;
    }
  });
  return errors;
}
